import { Component, h, JSX } from 'preact';
import { ERROR_CODES } from '../../../constants/errorcodes';
import { SDK_EVENTS } from '../../../constants/events.cnst';

interface ErrorInfo {
  componentStack?: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

interface ErrorBoundaryProps {
  hostInstance: any;
  children?: preact.ComponentChildren;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }
  static getDerivedStateFromError(error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error caught by ErrorBoundary:', error);
    console.error('Error info:', errorInfo); 
    this.props.hostInstance.emit(SDK_EVENTS.ON_ERROR, ERROR_CODES['ERR_JS_CODE']);
    this.setState({ error, errorInfo });
  }


 
  render(): JSX.Element {
    if (this.state.hasError) {
        console.log(this.state.error, "error");
        const languageData = this.props?.hostInstance?.languagedata
        
      return (
        <div>
          <h1>{languageData.SOMETHING_WRONG}.</h1>
          <details style={{ whiteSpace: 'pre-wrap' }}>
            <summary>{languageData.CLICK_ERROR_DETAILS}</summary>
            <p>{this.state.error && this.state.error.toString()}</p>
            <p>{this.state.errorInfo?.componentStack}</p>
          </details>
        </div>
      );
    }

    return this.props.children as JSX.Element;
  }
}

export default ErrorBoundary;